<template>
<b-container class="px-3 px-lg-5 py-6" fluid>
  <b-row class="py-lg-5">
    <b-col
      cols="12"
      lg="2"
      offset-lg="2"
      class="text-center"
      >
      <b-img
	:src="require('../assets/trinity_secure.png')"
	class="pb-2"
	style="max-width: 200px; width: 100%; height: auto;"
	/>
    </b-col>
    <b-col
      cols="12"
      lg="6"
      class="px-5"
      >
      <h1 class="text-center text-lg-left">All Systems In-house</h1>
      <div class="text-center text-lg-left">
	<p>All your Systems, All TrinPods, The Conceptual Computing System and the Graph Database and Dashboards and your data.</p>
	<p>All Installed and running locally, where you need to have it, behind your firewalls.
	</p>
	<p>Or if you like, in the Cloud.</p>
	<p>Your Choice!</p>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <div class="text-center py-5">
	<b-button
	  size="lg"
	  class="btn-neon-blue mr-3"
	  href="https://forms.zohopublic.com/graphmetrix/form/RequestCallbackregardingTrinityProperty/formperma/lDiSlWacpjS1U9urdnU0uX3VRKaLcQapRH0xZ2P_j1Q"
	  target="_blank">
	  Request Meeting
	</b-button>
      </div>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "AllSystemsInHouse",
    methods: {
	img: function (image) {
	    require(image)
	}
    }
}
</script>
